import React from 'react';
import {
  List,
  ListItemText,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { FortressTextIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { BASE_LIST_SX, NAV_ICON_MAP } from './constants';
import FortressLogoListItem from './FortressLogoListItem';
import NavListItem from './NavListItem';

const NavIconTextList = ({
  environmentName,
  flags,
  initialOpenState,
  isXs,
  navOptionsArray,
  open,
  propertyDetails,
  setOpen,
  showNavText,
  isTransitioning = false,
  setIsTransitioning = () => {},
  previousHeight = 0,
  setPreviousHeight = () => {},
  activeMenu = null,
  isNavigatingDown = true,
  resetHeight = false,
}) => {
  return (
    <List
      sx={{
        ...BASE_LIST_SX(flags),
        left: 0,
        width: '100%',
        opacity: showNavText ? 1 : 0,
      }}
    >
      <FortressLogoListItem>
        <ListItemText
          primary={
            <FortressTextIcon
              color={'primary'}
              sx={{
                fontSize: '100px !important',
                position: 'absolute',
                top: -38,
              }}
            />
          }
          secondary={environmentName}
          primaryTypographyProps={{
            height: 26,
            position: 'relative',
          }}
          secondaryTypographyProps={{ variant: 'bodySmall' }}
        />
      </FortressLogoListItem>

      {navOptionsArray?.map((navOption) => {
        return (
          <NavListItem
            key={navOption.value}
            {...navOption}
            icon={NAV_ICON_MAP[navOption.value]}
            isXs={isXs}
            open={open[navOption.value]}
            setOpen={(value) =>
              setOpen({
                ...initialOpenState,
                [navOption.value]: value ?? true,
              })
            }
            propertyDetails={propertyDetails}
            flags={flags}
            isTransitioning={isTransitioning}
            setIsTransitioning={setIsTransitioning}
            previousHeight={previousHeight}
            setPreviousHeight={setPreviousHeight}
            isActiveMenu={activeMenu === navOption.value}
            isNavigatingDown={isNavigatingDown}
            resetHeight={resetHeight}
          />
        );
      })}
    </List>
  );
};

export default NavIconTextList;
